import { Group, Mesh, Object3D } from "three";
import { last, uniq } from "lodash";
import gsap from "gsap";
import { delimiter } from "../pages/Exporter/Exporter";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { AnimationClip } from "three/src/Three";
export const findMorphableMeshes = (parent: Group | Mesh | Object3D): Mesh[] => {
    let morphables: Mesh[] = [];
    if (parent instanceof Mesh && parent.morphTargetInfluences) {
        morphables.push(parent);
    }
    parent.children.forEach((child) => {
        morphables = [
            ...morphables,
            ...(findMorphableMeshes(child))
        ];
    });
    return morphables;

}

export const applyProperties = (model: GLTF | Group, properties: {[key: string]: number}, coreMorphActions?: AnimationClip[]) => {
    const morphActions = coreMorphActions ?? model?.animations.filter(animation => animation.name.split(delimiter)[0] === 'Morph');

    const propertyTypes = uniq(Object.keys(properties).map(string => string.split(delimiter)[0]));
    propertyTypes.forEach((type: string) => {
        const props: [string,number][] = [];
        Object.keys(properties).filter(prop => prop.split(delimiter)[0] === type).forEach((key) => {
            props.push([key, properties[key]]);
        });

        switch (type) {
            case 'Morph':
                props.forEach(([name, value]) => {
                    const animations = morphActions
                        .filter(animation => animation.name === name);

                    animations.forEach((animation) => {
                        animation.tracks.forEach((track, trackIndex) => {
                            const [name, property] = track.name.split('.');
                            const mesh = findMeshWithName(name, !(model instanceof Group) ? model?.scene : model);
                            let args: any = {
                                duration: 1,
                            }
                            const firstValue = track.values[0];
                            const lastValue = last(track.values) as number;
                            const actualValueToSet = (lastValue - firstValue) * value + firstValue;

                            switch(property) {
                                case 'morphTargetInfluences':
                                    // @ts-ignore
                                    if (mesh.morphTargetInfluences[trackIndex] === undefined) {
                                        return;
                                    }
                                    args[trackIndex] = actualValueToSet;
                                    // @ts-ignore
                                    gsap.to(mesh.morphTargetInfluences, args);
                                break;
                                case 'scale':
                                    args = {
                                        ...args,
                                        x: actualValueToSet,
                                        y: actualValueToSet,
                                        z: actualValueToSet,
                                    }
                                    // @ts-ignore
                                    gsap.to(mesh?.scale, args);
                                break;
                                default:
                                    console.error('No idea what to do here');
                                break;
                            }
                        })
                    });
                })
            break;
            case 'Scale':
            default:
                props.forEach(([name, value]) => {
                    const mesh = findMeshWithName(name, !(model instanceof Group) ? model?.scene : model);
                    if (mesh) {
                        const args: any = {
                            duration: 1,
                            x: value,
                            y: value,
                            z: value,
                        }
                        gsap.to(mesh.scale, args);
                    }
                })
            break;
        }


    });
}
export const findMeshWithName = (name: string, object: Object3D): Mesh|Group|Object3D|undefined => {
    if (object.name === name) {
        return object;
    }
    let found: Object3D|Mesh|Group|undefined;
    object.children.forEach((child) => {
        if (found) return;
        found = findMeshWithName(name, child);
    });
    return found;
}
